export const PASSWORD_ERROR_CODES = {
  OLD_NEW_PASSWORD_SAME: 'OLD_NEW_PASSWORD_SAME',
  INVALID_PASSWORD: 'INVALID_PASSWORD',
  PASSWORD_TOO_SHORT: 'PASSWORD_TOO_SHORT',
  PASSWORD_INSECURE: 'PASSWORD_INSECURE',
  PASSWORD_TOO_LONG: 'PASSWORD_TOO_LONG',
};
